export interface Tag {
  id: number;
  name: string;
  context: string;
  contextName?: string;
  parentId?: number | null;
}

export enum TagContexts {
  Materials = 'materials',
  ProductionMethods = 'production_methods',
  ProductionMethodFeatures = 'production_method_features',
  RestrictedMethods = 'restricted_methods',
  ProductionRisks = 'production_risks',
  AuditNeedInfoReasons = 'audit_need_info_reasons',
  DrawingsNeedInfoReasons = 'drawings_need_info_reasons',
}
